import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
  mobileImageAspectRatio?: string;
}

const useStyles = makeStyles<Props>({
  name: 'HighlightMediaTextFiftyFifty',
})(({ brandColors, breakpoints, aspectRatio, typography, spacing }, props) => ({
  container: {
    backgroundColor: darkOrLightStyle(props)(
      brandColors.tintsHeroBlue10,
      brandColors.tintsOffWhite60
    ),
  },
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    rowGap: spacing(2),
    [breakpoints.up('sm')]: {
      rowGap: spacing(3),
    },
    [breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    '&.invert': {
      [breakpoints.up('md')]: {
        flexDirection: 'row-reverse',
      },
    },
    '&.invertOnMobile': {
      [breakpoints.down('md')]: {
        flexDirection: 'column-reverse',
      },
    },
  },
  mediaContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  halfImage: {
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'center center',
    aspectRatio: props.mobileImageAspectRatio || aspectRatio['4/3'],
    borderRadius: typography.pxToRem(16),

    [breakpoints.up('md')]: {
      aspectRatio: aspectRatio['4/3'],
    },
  },
}));

export default useStyles;
